import { DeviceConfigurationForm } from '@root/src/modules/devices/domain/models/device-configuration-form.ts';
import { admGraphqlRequest } from 'core/utils/backend-service';
import { DeviceSettingsGeneralConfiguration } from '../settings-device-configuration-status-tracking/settings-device-configuration-status-tracking.model';
import {
    DeviceConfigurationInstance,
    DeviceLayoutConfigSectionDetails,
    DeviceLayoutConfiguration,
} from '../settings-devices-configuration-layout/settings-devices-configuration-layout.model';
import { DeviceConfigurationInfo } from '../settings-devices-configuration-list/settings-devices-configuration-list.model';
import {
    mapCleaningPropertiesSettingsToApi,
    mapGeneralDeviceSettingsConfiguration,
    mapQcPropertiesSettingsToApi,
    mapSettingsDeviceConfigurationModelToApi,
} from './device-settings-config.mapper';
import {
    changeConfigurationInstanceToDefaultQuery,
    copyConfiguration,
    getConfigurationListQuery,
    getDeviceConfigurationInstanceQuery,
    getGeneralDeviceConfigurationQuery,
    getLayoutSectionsQuery,
    getSectionDetailsQuery,
    saveDeviceConfigurationInstanceQuery,
    updateConfigurationInstancesActiveStatusQuery,
    updateGeneralDeviceConfigurationQuery,
} from './settings-device-configuration.queries';
import {
    mapSectionDetailsApiToModel,
    mapSettingsDeviceConfigurationApiToModel,
} from './settings-device-configuration-queries.mapper';

export const getLayoutSections = (deviceTypeId: string): Promise<DeviceLayoutConfiguration> =>
    admGraphqlRequest(getLayoutSectionsQuery(), { deviceTypeId }).then((result) => result.data.layout);

export const getSectionDetails = (
    layoutId: string,
    layoutSectionId: string
): Promise<DeviceLayoutConfigSectionDetails> =>
    admGraphqlRequest(getSectionDetailsQuery(), { layoutId, sectionId: layoutSectionId }).then((result) =>
        mapSectionDetailsApiToModel(result.data.sectionLayout)
    );

export const getDeviceConfigurationList = (
    deviceTypeId: string,
    onlyActive: boolean = true
): Promise<DeviceConfigurationInfo[]> =>
    admGraphqlRequest(getConfigurationListQuery(), { deviceTypeId, onlyActive }).then(
        (result) => result.data.deviceConfigurations
    );

export const copyConfigurationInstance = (instance: DeviceConfigurationForm): Promise<string> =>
    admGraphqlRequest(copyConfiguration(), { instance }).then((result) => result.data.copyConfigurationInstance);

export const getDeviceConfigurationInstance = (deviceConfigurationId: string) =>
    admGraphqlRequest(getDeviceConfigurationInstanceQuery(), { deviceConfigurationId }).then((result) =>
        mapSettingsDeviceConfigurationApiToModel(result.data.configurationInstance)
    );

export const saveDeviceConfigurationInstance = (instance: DeviceConfigurationInstance): Promise<string> =>
    admGraphqlRequest(saveDeviceConfigurationInstanceQuery(), {
        instance: mapSettingsDeviceConfigurationModelToApi(instance),
    }).then((result) => result.data.editConfigurationInstance);

export const changeConfigurationInstanceToDefault = (deviceConfigurationId: string): Promise<string> =>
    admGraphqlRequest(changeConfigurationInstanceToDefaultQuery(), { deviceConfigurationId }).then(
        (result) => result.data.changeConfigurationInstanceToDefault
    );

export const updateConfigurationInstancesActiveStatus = (
    configurationInstanceIds: string[],
    active: boolean
): Promise<string> =>
    admGraphqlRequest(updateConfigurationInstancesActiveStatusQuery(), {
        configurationInstanceIds,
        active,
    }).then((result) => result.data.updateConfigurationInstancesActiveStatus);

export const getGeneralDeviceSettingsConfiguration = (
    deviceTypeId: string
): Promise<DeviceSettingsGeneralConfiguration> =>
    admGraphqlRequest(getGeneralDeviceConfigurationQuery(), { deviceTypeId }).then((result) =>
        mapGeneralDeviceSettingsConfiguration(result.data.generalDeviceConfiguration)
    );

export const updateGeneralDeviceConfiguration = (
    deviceTypeId: string,
    { connectivityProperties, qcProperties, cleaningProperties }: DeviceSettingsGeneralConfiguration
): Promise<boolean> =>
    admGraphqlRequest(updateGeneralDeviceConfigurationQuery(), {
        deviceTypeId,
        connectivity: connectivityProperties,
        qc: mapQcPropertiesSettingsToApi(qcProperties),
        cleaning: cleaningProperties && mapCleaningPropertiesSettingsToApi(cleaningProperties),
    }).then(() => true);
